const getters = {
    getToken: state => state.token,
    getUser: state => state.user
}




export default getters;
